import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useGetUser } from 'app/api/hooks/core/v1/auth/user';
import { CompanyTypeId } from 'app/constants/user';
import LoadingScreen from 'app/pages/shared/LoadingScreen';

// Local Typings
interface Props {
  permittedCompanyTypeIds: CompanyTypeId[];
}

// Component Definition
const CompanyTypeRestrictor: FC<PropsWithChildren<Props>> = ({ children, permittedCompanyTypeIds }) => {
  const user = useGetUser();

  if (!user) {
    return <LoadingScreen />;
  }

  // eslint-disable-next-line @stylistic/max-len
  const isPermitted: boolean = !!user?.company?.type.id && permittedCompanyTypeIds.includes(user.company.type.id as CompanyTypeId);

  if (isPermitted) {
    return children;
  }

  return <Navigate to="/" />;
};

export default CompanyTypeRestrictor;
